import { isPlatformBrowser } from '@angular/common';
import { Component, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import { AccountFacade } from 'ish-core/facades/account.facade';
import { LoadingComponent } from 'ish-shared/components/common/loading/loading.component.all';

@Component({
  selector: 'app-azure-callback',
  template: `
    <ish-loading></ish-loading>
    <p>Finalizing Azure login...</p>
  `,
  imports: [LoadingComponent],
})
export class AzureCallbackComponent implements OnInit {
  constructor(@Inject(PLATFORM_ID) private platformId: object, private accountFacade: AccountFacade) {}
  ngOnInit() {
    if (isPlatformBrowser(this.platformId)) {
      // Set the identity provider early to avoid fallback to ICM
      this.accountFacade.setIdentityProvider('Azure');
    }
  }
}
